export const SYSTEM_MENU_IDS={
    MICore :1,
    MIBroker:295
};
export const SYSTEM_IDS={
    MICore :3,
    SSO: 1,
    MIBroker:4
};
